<template>
  <div>
    Display Cloud Storage Setup Here...
  </div>
</template>

<script>
export default {
  name: 'CloudStorage',
  data: function () {
    return {
    }
  },
  computed: {
  },
  methods: { },
}
</script>

<style lang="scss" scoped>
</style>
